import { useState } from "react";
import { placess, act, office } from "../../../data/globalData";
import { useTranslation } from "react-i18next";
import {
    ArrowDropDown,
    Email,
    FileUpload,
    MessageOutlined,
    PersonOutline,
    Phone,
} from "@mui/icons-material";
import {
    formatTurkmenPhone,
    isActRequestFormComplete,
} from "../../../Helper/actRequestHelpers";

const Juridical = ({
    data,
    setData,
    handlePost,
    isLoading,
    errors,
    clearError,
}) => {
    const { t } = useTranslation();

    const [showVelayatDropdown, setShowVelayatDropdown] = useState(false);
    const [showEtrapDropdown, setShowEtrapDropdown] = useState(false);
    const [showActDropdown, setShowActDropdown] = useState(false);
    const [showPlacesDropdown, setShowPlacesDropdown] = useState(false);
    const [etrapOptions, setEtrapOptions] = useState([]);

    const ErrorText = ({ name }) => {
        if (!errors?.[name]) return null;

        return (
            <p className="text-red text-xs font-medium mb-2">
                {errors[name]}
            </p>
        );
    };

    const getInputClass = (field) => {
        return errors?.[field] ? "border-red" : "border-border";
    };

    const updateField = (field, value) => {
        setData({
            ...data,
            [field]: value,
        });

        clearError(field);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        setData({
            ...data,
            attachment: file || null,
        });

        clearError("attachment");
    };

    const handlePhoneNumberChange = (e) => {
        const phone = formatTurkmenPhone(e.target.value);

        setData({
            ...data,
            phone_number: phone,
        });

        clearError("phone_number");
    };

    const handleVelayatSelect = (velayat) => {
        setData({
            ...data,
            province: velayat.title,
            district: "",
        });

        clearError("province");
        clearError("district");

        setEtrapOptions(velayat.content);
        setShowVelayatDropdown(false);
    };

    const handleEtrapSelect = (etrap) => {
        setData({
            ...data,
            district: etrap.name,
        });

        clearError("district");
        setShowEtrapDropdown(false);
    };

    const handleActSelect = (actItem) => {
        setData({
            ...data,
            act: actItem.name,
        });

        clearError("act");
        setShowActDropdown(false);
    };

    const handlePlaceSelect = (officeItem) => {
        setData({
            ...data,
            places: officeItem.name,
        });

        clearError("places");
        setShowPlacesDropdown(false);
    };

    const handleRequesterPost = () => {
        handlePost("organization");
    };

    const isComplete = isActRequestFormComplete(data, "organization");
    const buttonColor = isComplete ? "bg-green" : "bg-primary";

    return (
        <form>
            <div className="mb-4 lg:flex justify-between gap-8">
                <div className="w-full relative mt-4 lg:mt-0">
                    <input
                        type="text"
                        name="institution_name"
                        value={data.organization_name}
                        onChange={(e) =>
                            updateField("organization_name", e.target.value)
                        }
                        placeholder={t("institution_name")}
                        className={`px-4 py-2 border bg-secondary 
                        rounded w-full mt-1 focus:outline-none 
                        focus:ring-2 mb-1 focus:ring-indigo-500 
                        dark:text-white dark:bg-dark-box 
                        dark:border-dark-border
                        ${getInputClass("organization_name")}`}
                    />

                    <ErrorText name="organization_name" />
                </div>
            </div>

            <div className="mb-4 mt-6 lg:flex justify-between gap-8">
                <div className="lg:w-[50%] relative">
                    <div className="relative">
                        <input
                            type="text"
                            name="velayat"
                            value={data.province}
                            placeholder={t("select_province")}
                            readOnly
                            className={`w-full px-4 py-2 border rounded 
                          bg-secondary dark:bg-dark-box dark:border-dark-border 
                          focus:outline-none focus:ring-2 mb-1 cursor-pointer
                          focus:ring-indigo-500 dark:text-white
                          ${getInputClass("province")}`}
                            onClick={() => setShowVelayatDropdown(!showVelayatDropdown)}
                        />

                        <ArrowDropDown
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 
                         text-blackOpacity dark:text-dark-text"
                        />
                    </div>

                    <ErrorText name="province" />

                    {showVelayatDropdown && (
                        <div
                            className="absolute top-full mt-[-7px] left-0 w-full bg-white 
                         border z-10 max-h-64 overflow-y-auto
                         dark:bg-dark-box shadow-lg border-secondary
                         dark:border-dark-border dark:text-dark-text
                         p-2 rounded-md input-table"
                        >
                            {placess.map((velayat) => (
                                <div
                                    key={velayat.id}
                                    onClick={() => handleVelayatSelect(velayat)}
                                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                >
                                    {velayat.title}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <div className="relative">
                        <input
                            type="text"
                            name="etrap"
                            value={data.district}
                            placeholder={t("select_county")}
                            readOnly
                            className={`w-full px-4 py-2 border 
                          bg-secondary rounded cursor-pointer
                          focus:outline-none focus:ring-2 mb-1
                          focus:ring-indigo-500 dark:text-white 
                          dark:bg-dark-box dark:border-dark-border
                          ${getInputClass("district")}`}
                            onClick={() =>
                                data.province && setShowEtrapDropdown(!showEtrapDropdown)
                            }
                        />

                        <ArrowDropDown
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 
                         text-blackOpacity dark:text-dark-text"
                        />
                    </div>

                    <ErrorText name="district" />

                    {showEtrapDropdown && (
                        <div
                            className="absolute top-full mt-[-7px] left-0 w-full bg-white 
                         border z-10 max-h-64 overflow-y-auto
                         dark:bg-dark-box shadow-lg border-secondary
                         dark:border-dark-border dark:text-dark-text
                         p-2 rounded-md input-table"
                        >
                            {etrapOptions.map((etrap, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleEtrapSelect(etrap)}
                                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                >
                                    {etrap.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className="mb-4 lg:flex justify-between gap-8">
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className="flex items-center gap-1 text-sm dark:text-dark-text">
                        <PersonOutline style={{ fontSize: "18px", color: "#0039a6" }} />
                        {t("write_name")}
                    </label>

                    <input
                        type="text"
                        name="name"
                        value={data.first_name}
                        onChange={(e) => updateField("first_name", e.target.value)}
                        placeholder={t("write_name")}
                        className={`w-full px-4 py-2 border mt-1 mb-1
                        bg-secondary rounded focus:outline-none focus:ring-2 
                        focus:ring-indigo-500 dark:text-white 
                        dark:bg-dark-box dark:border-dark-border
                        ${getInputClass("first_name")}`}
                    />

                    <ErrorText name="first_name" />
                </div>

                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className="flex items-center gap-1 text-sm dark:text-dark-text">
                        <PersonOutline style={{ fontSize: "18px", color: "#0039a6" }} />
                        {t("write_surname")}
                    </label>

                    <input
                        type="text"
                        name="surname"
                        value={data.last_name}
                        onChange={(e) => updateField("last_name", e.target.value)}
                        placeholder={t("write_surname")}
                        className={`px-4 py-2 border bg-secondary rounded w-full mt-1
                        focus:outline-none focus:ring-2 mb-1
                        focus:ring-indigo-500 dark:text-white 
                        dark:bg-dark-box dark:border-dark-border
                        ${getInputClass("last_name")}`}
                    />

                    <ErrorText name="last_name" />
                </div>
            </div>

            <div className="mb-4 lg:flex justify-between gap-8">
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className="flex items-center gap-1 text-sm dark:text-dark-text">
                        <PersonOutline style={{ fontSize: "18px", color: "#0039a6" }} />
                        {t("write_patronymic")}
                    </label>

                    <input
                        type="text"
                        name="third_name"
                        placeholder={t("write_patronymic")}
                        value={data.patronimic}
                        onChange={(e) => updateField("patronimic", e.target.value)}
                        className={`w-full px-4 py-2 border mt-1
                        bg-secondary mb-1 rounded focus:outline-none 
                        focus:ring-2 focus:ring-indigo-500 dark:text-white 
                        dark:bg-dark-box dark:border-dark-border
                        ${getInputClass("patronimic")}`}
                    />

                    <ErrorText name="patronimic" />
                </div>

                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <label className="flex items-center gap-1 text-sm dark:text-dark-text">
                        <Email style={{ fontSize: "18px", color: "#0039a6" }} />
                        {t("email")}
                    </label>

                    <input
                        type="email"
                        name="email"
                        placeholder={t("email")}
                        value={data.email}
                        onChange={(e) => updateField("email", e.target.value)}
                        className={`px-4 py-2 border bg-secondary 
                        rounded w-full mt-1 focus:outline-none 
                        focus:ring-2 mb-1 focus:ring-indigo-500 
                        dark:text-white dark:bg-dark-box 
                        dark:border-dark-border
                        ${getInputClass("email")}`}
                    />

                    <ErrorText name="email" />
                </div>
            </div>

            <div className="mb-4 lg:flex justify-between gap-8">
                <div className="lg:w-[50%] relative">
                    <div className="relative">
                        <input
                            type="text"
                            name="places"
                            value={data.places}
                            placeholder={t("select_category")}
                            readOnly
                            className={`w-full px-4 py-2 border rounded 
                          bg-secondary dark:bg-dark-box dark:border-dark-border 
                          focus:outline-none focus:ring-2 mb-1 cursor-pointer
                          focus:ring-indigo-500 dark:text-white mt-1
                          ${getInputClass("places")}`}
                            onClick={() => setShowPlacesDropdown(!showPlacesDropdown)}
                        />

                        <ArrowDropDown
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 
                         text-blackOpacity dark:text-dark-text"
                        />
                    </div>

                    <ErrorText name="places" />

                    {showPlacesDropdown && (
                        <div
                            className="absolute top-full mt-[-7px] left-0 w-full bg-white 
                         border z-10 max-h-64 overflow-y-auto
                         dark:bg-dark-box shadow-lg border-secondary
                         dark:border-dark-border dark:text-dark-text
                         p-2 rounded-md input-table"
                        >
                            {office.map((officeItem) => (
                                <div
                                    key={officeItem.id}
                                    onClick={() => handlePlaceSelect(officeItem)}
                                    className="px-4 py-2 hover:bg-secondary cursor-pointer"
                                >
                                    {officeItem.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="lg:w-[50%] relative">
                    <div className="relative">
                        <input
                            type="text"
                            name="act"
                            value={data.act}
                            placeholder={t("select_type")}
                            readOnly
                            className={`w-full px-4 py-2 border bg-secondary
                          rounded cursor-pointer focus:outline-none 
                          focus:ring-2 focus:ring-indigo-500 mt-1 mb-1
                          dark:bg-dark-box dark:border-dark-border
                          dark:text-white
                          ${getInputClass("act")}`}
                            onClick={() => setShowActDropdown(!showActDropdown)}
                        />

                        <ArrowDropDown
                            className="absolute right-2 top-1/2 transform -translate-y-1/2 
                         text-blackOpacity dark:text-dark-text"
                        />
                    </div>

                    <ErrorText name="act" />

                    {showActDropdown && (
                        <div
                            className="absolute top-full mt-[-7px] left-0 w-full 
                         border z-10 max-h-64 overflow-y-auto bg-white 
                         dark:bg-dark-box shadow-lg border-secondary
                         dark:border-dark-border dark:text-dark-text
                         p-2 rounded-md input-table"
                        >
                            {act.map((actItem) => (
                                <div
                                    key={actItem.id}
                                    onClick={() => handleActSelect(actItem)}
                                    className="px-4 py-2 hover:bg-secondary 
                             dark:hover:text-dark cursor-pointer"
                                >
                                    {actItem.name}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className="mb-4">
                <label className="flex items-center gap-1 text-sm dark:text-dark-text mt-6">
                    <MessageOutlined style={{ fontSize: "18px", color: "#0039a6" }} />
                    {t("your_message")}
                </label>

                <textarea
                    name="message"
                    placeholder={t("your_message")}
                    value={data.message}
                    onChange={(e) => updateField("message", e.target.value)}
                    className={`px-4 py-2 border mt-1
                      h-40 bg-secondary rounded w-full 
                      focus:outline-none focus:ring-2 mb-1
                      focus:ring-indigo-500 dark:text-white 
                      dark:bg-dark-box dark:border-dark-border
                      ${getInputClass("message")}`}
                />

                <ErrorText name="message" />
            </div>

            <div className="mb-4 lg:flex justify-between gap-8 items-end">
                <div className="lg:w-[50%] relative mt-4 lg:mt-0">
                    <div className="text-sm text-dark-border dark:text-dark-text">
                        {t("attach_file")} : (doc, docx, jpg, pdf, rtf, txt, odt, zip, rar,
                        png, tiff, jpeg, mp4, avi, mov, mp3, wav)
                    </div>

                    <input
                        type="file"
                        id="act-juridical-file-upload"
                        className="hidden"
                        onChange={handleFileChange}
                    />

                    <label
                        htmlFor="act-juridical-file-upload"
                        className={`w-max flex items-center justify-center 
                        px-4 py-2 text-white mt-2
                        rounded-md shadow-md cursor-pointer 
                        transition-all duration-300
                        ${errors?.attachment ? "bg-red" : "bg-primary"}`}
                    >
                        <FileUpload className="mr-2" />
                        {t("choose_file")}
                    </label>

                    {data.attachment && (
                        <div className="mt-2 text-sm text-dark-border dark:text-dark-text">
                            {t("chosen")} : {data.attachment.name}
                        </div>
                    )}

                    <ErrorText name="attachment" />
                </div>

                <div className="lg:w-[40%] relative mt-6 lg:mt-0">
                    <label className="flex items-center gap-1 text-sm dark:text-dark-text">
                        <Phone style={{ fontSize: "18px", color: "#0039a6" }} />
                        {t("phone_number")}
                    </label>

                    <input
                        type="text"
                        name="phone"
                        placeholder={t("phone_number")}
                        value={data.phone_number}
                        onChange={handlePhoneNumberChange}
                        className={`w-full px-4 py-2 border dark:text-dark-text
                        bg-secondary mb-1 mt-1 rounded
                        focus:outline-none focus:ring-2 focus:ring-indigo-500 
                        dark:bg-dark-box dark:border-dark-border
                        ${getInputClass("phone_number")}`}
                    />

                    <ErrorText name="phone_number" />
                </div>
            </div>

            <div className="w-full flex">
                <button
                    type="button"
                    className={`relative ${buttonColor} text-white px-6
                      py-2 mt-8 rounded ml-auto min-w-[100px]
                      flex items-center justify-center
                      ${isLoading ? "opacity-70 cursor-not-allowed" : ""}`}
                    onClick={handleRequesterPost}
                    disabled={isLoading}
                >
                    <span className={isLoading ? "invisible" : "visible"}>
                        {t("send")}
                    </span>

                    {isLoading && (
                        <span
                            className="absolute w-4 h-4 border-2 border-white 
                         border-t-transparent rounded-full animate-spin"
                        />
                    )}
                </button>
            </div>
        </form>
    );
};

export default Juridical;